import * as React from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.6663 9.16683H6.52467L11.183 4.5085L9.99967 3.3335L3.33301 10.0002L9.99967 16.6668L11.1747 15.4918L6.52467 10.8335H16.6663V9.16683Z" }));
export default SvgBack;
